export type Category = {
  id: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
};

export const categories: Category[] = [
  { id: 'c1', name: '娱乐八卦', icon: 'ri-vip-crown-line', count: 32, desc: '艺人动态、片场花絮与圈内传闻的集中入口' },
  { id: 'c2', name: '情感内幕', icon: 'ri-heart-3-line', count: 26, desc: '情感纠纷、关系走向与当事人自述的整理' },
  { id: 'c3', name: '职场爆料', icon: 'ri-briefcase-line', count: 21, desc: '公司内幕、行业变动与用人问题的线索汇总' },
  { id: 'c4', name: '网红动态', icon: 'ri-camera-lens-line', count: 28, desc: '主播、博主与短视频圈的最新动向' },
  { id: 'c5', name: '校园圈', icon: 'ri-graduation-cap-line', count: 18, desc: '高校事件、社团换届与校园话题的归档' },
  { id: 'c6', name: '财经背后', icon: 'ri-line-chart-line', count: 15, desc: '商业操作、股权变化与资金流向的梳理' },
  { id: 'c7', name: '探店避雷', icon: 'ri-store-2-line', count: 23, desc: '门店体验、消费纠纷与真实评价的对比' },
  { id: 'c8', name: '生活观察', icon: 'ri-user-voice-line', count: 19, desc: '城市生活、租房与日常矛盾的记录' },
];

export type FeaturedCard = {
  id: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  views: string;
  cover: string;
};

export const featuredCards: FeaturedCard[] = [
  {
    id: 'f1',
    category: '娱乐八卦',
    title: '某综艺录制现场临时换人，知情人还原完整经过',
    summary: '从彩排到录制当天的时间线被逐条整理，出现在镜头里的细节成为讨论焦点。',
    date: '09-12',
    views: '3.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20scene%20of%20an%20empty%20vintage%20leather%20armchair%20beside%20a%20tall%20window%2C%20soft%20golden%20afternoon%20light%2C%20cream%20tones%2C%20minimal%20interior%20photography%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heila-cover-01&orientation=landscape',
  },
  {
    id: 'f2',
    category: '网红动态',
    title: '头部主播停播一周后复播，直播间数据出现明显波动',
    summary: '复播首场的在线人数、停留时长与选品变化被对比列出，粉丝反应两极。',
    date: '09-11',
    views: '2.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20urban%20street%20corner%20in%20warm%20evening%20light%20with%20plain%20walls%20and%20long%20shadows%2C%20amber%20and%20cream%20palette%2C%20calm%20documentary%20style%20photography%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heila-cover-02&orientation=landscape',
  },
  {
    id: 'f3',
    category: '职场爆料',
    title: '大厂裁员名单流出，多个业务线同步调整',
    summary: '涉及部门、赔偿方案与内部沟通节奏，被前员工按时间顺序补充说明。',
    date: '09-10',
    views: '1.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20office%20desk%20corner%20with%20a%20closed%20laptop%2C%20a%20small%20plant%20and%20blank%20sticky%20notes%2C%20warm%20neutral%20light%2C%20clean%20minimal%20editorial%20photography%2C%20cream%20and%20clay%20tones%2C%20no%20text&width=900&height=560&seq=heila-cover-03&orientation=landscape',
  },
  {
    id: 'f4',
    category: '探店避雷',
    title: '网红餐厅排队两小时后，食客晒出真实出品对比',
    summary: '宣传图与到店实拍被摆在一起，店内回应与原帖说法并不一致。',
    date: '09-10',
    views: '1.5万',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20cafe%20interior%20with%20wooden%20tables%20and%20hanging%20warm%20lights%2C%20empty%20seats%2C%20soft%20focus%2C%20cream%20and%20caramel%20tones%2C%20editorial%20lifestyle%20photography%2C%20no%20text&width=900&height=560&seq=heila-cover-04&orientation=landscape',
  },
  {
    id: 'f5',
    category: '校园圈',
    title: '高校社团换届引发争议，多份聊天记录被公开',
    summary: '换届流程、投票结果与当事人自述被整理成一份可核对的时间轴。',
    date: '09-09',
    views: '1.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20library%20corner%20with%20stacked%20books%20and%20a%20reading%20lamp%2C%20warm%20lamp%20glow%2C%20cream%20and%20amber%20palette%2C%20minimal%20editorial%20still%20life%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heila-cover-05&orientation=landscape',
  },
  {
    id: 'f6',
    category: '财经背后',
    title: '某品牌融资细节曝光，估值口径前后矛盾',
    summary: '公开资料与内部邮件口径差异明显，投资方暂未正面回应。',
    date: '09-08',
    views: '9800',
    cover:
      'https://readdy.ai/api/search-image?query=Neat%20flat%20lay%20of%20a%20smartphone%2C%20a%20blank%20notebook%20and%20a%20coffee%20cup%20on%20a%20warm%20beige%20desk%2C%20soft%20daylight%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heila-cover-06&orientation=landscape',
  },
];

export type Topic = {
  id: string;
  title: string;
  desc: string;
  count: number;
  tag: string;
  cover: string;
};

export const topics: Topic[] = [
  {
    id: 't1',
    title: '选秀生态观察',
    desc: '收录选秀节目台前台后的完整脉络，从选手背景到赛制变化逐条整理。',
    count: 18,
    tag: '专题',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20desk%20scene%20with%20stacked%20folded%20newspapers%20and%20blank%20paper%20clippings%20arranged%20neatly%2C%20soft%20natural%20window%20light%2C%20cream%20and%20amber%20tones%2C%20editorial%20still%20life%20photography%2C%20no%20text&width=900&height=600&seq=heila-topic-01&orientation=landscape',
  },
  {
    id: 't2',
    title: '直播行业档案',
    desc: '主播合同、平台规则与停播事件的系统归档，全部按时间线排列。',
    count: 24,
    tag: '档案',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20studio%20table%20top%20with%20an%20open%20notebook%2C%20blank%20index%20cards%20and%20a%20fountain%20pen%2C%20soft%20warm%20daylight%2C%20cream%20beige%20palette%2C%20clean%20minimalist%20editorial%20composition%2C%20no%20text&width=900&height=600&seq=heila-topic-02&orientation=landscape',
  },
  {
    id: 't3',
    title: '职场变动记录',
    desc: '裁员、跳槽与行业收缩的合集，覆盖多个行业的关键时间节点。',
    count: 16,
    tag: '合集',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20archive%20shelf%20with%20pastel%20card%20folders%20neatly%20lined%20up%2C%20warm%20ambient%20lighting%2C%20cream%20and%20clay%20tones%2C%20calm%20organizational%20still%20life%2C%20no%20text%2C%20editorial%20photography&width=900&height=600&seq=heila-topic-03&orientation=landscape',
  },
  {
    id: 't4',
    title: '消费避雷指南',
    desc: '门店、产品与服务体验的对比整理，只保留可核对的具体细节。',
    count: 21,
    tag: '指南',
    cover:
      'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20blank%20paper%20cards%20and%20wooden%20clips%20arranged%20in%20a%20grid%20on%20a%20warm%20neutral%20surface%2C%20soft%20shadows%2C%20tidy%20minimal%20editorial%20style%2C%20cream%20and%20amber%20palette%2C%20no%20text&width=900&height=600&seq=heila-topic-04&orientation=landscape',
  },
];

export type TagGroup = {
  id: string;
  title: string;
  icon: string;
  tags: string[];
};

export const tagGroups: TagGroup[] = [
  {
    id: 'g1',
    title: '人物标签',
    icon: 'ri-user-3-line',
    tags: ['艺人', '主播', '创始人', '前员工', '当事人', '经纪人', '路人视角'],
  },
  {
    id: 'g2',
    title: '事件标签',
    icon: 'ri-alarm-warning-line',
    tags: ['签约风波', '临时换人', '数据造假', '价格争议', '公开回应', '录音流出', '合同纠纷'],
  },
  {
    id: 'g3',
    title: '地区标签',
    icon: 'ri-map-pin-2-line',
    tags: ['北京', '上海', '广州', '成都', '杭州', '深圳', '武汉'],
  },
  {
    id: 'g4',
    title: '题材标签',
    icon: 'ri-bookmark-3-line',
    tags: ['情感', '职场', '娱乐', '商业', '校园', '生活', '消费'],
  },
  {
    id: 'g5',
    title: '形式标签',
    icon: 'ri-layout-masonry-line',
    tags: ['长文整理', '时间线', '图文对比', '采访实录', '资料归档'],
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: '黑料网1是怎么给内容分类的？',
    a: '站点按栏目、专题、标签三层划分。栏目是大的入口方向，专题是围绕一个话题整理出的合集，标签则用来按人物、事件、地区等维度做二次筛选。想找特定类型的料，从任意一层进入都可以。',
  },
  {
    q: '同一个话题在专题和标签里都能看到，有什么区别？',
    a: '专题是按时间线人工整理过的完整脉络，顺序清晰、上下文完整；标签是自动归集的入口，覆盖面更广但排序更简单。想看来龙去脉用专题，想找某个具体的点用标签。',
  },
  {
    q: '标签目录里的标签会固定不变吗？',
    a: '不会。标签会跟随内容增减做调整，热点过去后部分标签会合并或下线。目录页会尽量保持每个分组的标签数量稳定，避免出现只有一两条内容的空标签。',
  },
  {
    q: '想看某个地区的内容，从哪里进最快？',
    a: '在标签目录的「地区标签」分组里直接点城市名即可进入对应入口；也可以使用页面顶部的搜索框输入城市名，栏目和标签会同步筛选出匹配结果。',
  },
  {
    q: '更新记录多久同步一次？',
    a: '本页为目录结构演示，更新记录为静态示例数据，用于说明栏目与标签的维护方式，不代表真实的内容更新频率。',
  },
  {
    q: '页面里的内容是经过核实的吗？',
    a: '本页中的栏目、专题、标签与卡片均为示例文案，仅用于展示「黑料网1」分类导航的组织方式与浏览路径，不代表任何真实事件或人物。',
  },
];

export type UpdateItem = {
  time: string;
  text: string;
  tag: string;
};

export const updates: UpdateItem[] = [
  { time: '09-12 14:20', text: '新增专题《选秀生态观察》，收录 18 篇整理内容', tag: '新增' },
  { time: '09-12 10:05', text: '《直播行业档案》补充 3 条时间线节点', tag: '更新' },
  { time: '09-11 21:40', text: '地区标签新增「武汉」，与现有 6 个城市保持同一分组', tag: '标签' },
  { time: '09-11 09:15', text: '职场变动记录归档完成，共 16 篇', tag: '归档' },
  { time: '09-10 18:30', text: '消费避雷指南调整排序规则，改为按时间倒序展示', tag: '调整' },
  { time: '09-10 08:50', text: '首页大图卡片流上线，封面优先展示', tag: '上线' },
];

export type Stat = {
  label: string;
  value: string;
};

export const stats: Stat[] = [
  { label: '栏目分类', value: '8' },
  { label: '专题板块', value: '24' },
  { label: '标签条目', value: '120+' },
  { label: '收录整理', value: '360+' },
];

export type TrustPoint = {
  icon: string;
  title: string;
  desc: string;
};

export const trustPoints: TrustPoint[] = [
  {
    icon: 'ri-node-tree',
    title: '三层分类，入口清晰',
    desc: '栏目定方向、专题看脉络、标签做筛选，每一层都指向明确的浏览路径。',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '标签目录，按维度找',
    desc: '人物、事件、地区、题材、形式五个分组，按你想找的角度直接进入。',
  },
  {
    icon: 'ri-history-line',
    title: '更新记录可查',
    desc: '新增、归档与调整都留有记录，目录结构的变化过程同样一目了然。',
  },
];